<div id="container">

  <app-navigation></app-navigation>

  <div>

    <app-alerts></app-alerts>

    <section id="content">
      <router-outlet></router-outlet>
    </section>

  </div>

</div>

<app-footer></app-footer>
